import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// PrimeNG
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';
import { ChipModule } from 'primeng/chip';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SkeletonModule } from 'primeng/skeleton'; // Agregado para skeletons
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { AutoCompleteModule } from 'primeng/autocomplete';

// Shared Module (contiene ProductoSelectBusquedaComponent)
import { SharedModule } from '../../shared.module';
import { ProductoSelectBusquedaModule } from '../producto-select-busqueda/producto-select-busqueda.module';

// Component
import { AgregarListaProductosUnitariaModalComponent } from './agregar-lista-productos-unitaria-modal.component';

@NgModule({
  declarations: [AgregarListaProductosUnitariaModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    ProgressSpinnerModule,
    TooltipModule,
    ChipModule,
    ScrollPanelModule,
    SkeletonModule, // Agregado para skeletons
    InputGroupModule,
    InputGroupAddonModule,
    SharedModule,
    AutoCompleteModule,
    ProductoSelectBusquedaModule,
  ],
  exports: [AgregarListaProductosUnitariaModalComponent],
})
export class AgregarListaProductosUnitariaModalModule {}
